export default "/images/112226bbfc5c2f8ea7695221fbd0ff04.avif";